(function () {
  'use strict';

  document.querySelectorAll('[data-watch]').forEach(function (root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-watch-panel]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-watch-item]'));
    if (!panels.length || panels.length !== items.length) return;

    function videoOf(panel) {
      return panel.querySelector('video');
    }

    function stop(panel) {
      var video = videoOf(panel);
      if (video) {
        video.pause();
        video.controls = false;
      }
      panel.classList.remove('is-playing');
    }

    function play(panel) {
      var video = videoOf(panel);
      if (!video) return;
      panel.classList.add('is-playing');
      video.controls = true;
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    }

    // Wire "ended" so the cover comes back when a film finishes.
    panels.forEach(function (panel) {
      var video = videoOf(panel);
      if (video) video.addEventListener('ended', function () { stop(panel); });

      var playBtn = panel.querySelector('[data-watch-play]');
      if (playBtn) playBtn.addEventListener('click', function () { play(panel); });
    });

    function select(index) {
      panels.forEach(function (panel, i) {
        var active = i === index;
        if (!active) stop(panel);
        panel.classList.toggle('is-active', active);
        items[i].classList.toggle('is-active', active);
        items[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        var alreadyActive = panels[index].classList.contains('is-active');
        select(index);
        // Picking a film starts it, as the copy says: "Pick one — it plays here."
        if (!alreadyActive || !panels[index].classList.contains('is-playing')) {
          play(panels[index]);
        }
      });
    });
  });
})();
